import Vue from 'vue';
import api from '../bu/api';

export default {
	namespaced: true,

	state: () => ({
		extraHours: {},
		extraHoursArray: []
	}),

	getters: {
		extraHours(state) {
			return state.extraHoursArray;
		}
	},

	actions: {
		async getAllMemberExtraHours({commit}, {startTime, endTime}) {
			const response = await api.getAllMemberExtraHours(startTime, endTime);
			commit('setExtraHours', response.data);
			return response.data.map((eh) => eh.id);
		},
		async getMemberExtraHours({commit}, {memberUserId, startTime, endTime}) {
			const response = await api.getMemberExtraHours(memberUserId, startTime, endTime);
			commit('setExtraHours', response.data);
			return response.data.map((eh) => eh.id);
		},
		deleteMemberExtraHours({commit}, extraHoursId) {
			commit('deleteExtraHours', extraHoursId);
		}
	},

	mutations: {
		setExtraHours(state, extraHours) {
			extraHours.forEach((eh) => {
				Vue.set(state.extraHours, eh.id, eh);
			});
			Vue.set(state, 'extraHoursArray', Object.values(state.extraHours));
		},
		deleteExtraHours(state, extraHoursId) {
			Vue.delete(state.extraHours, extraHoursId);
			Vue.set(state, 'extraHoursArray', Object.values(state.extraHours));
		}
	},
}